module.exports = __webpack_public_path__ + "img/flag_uk.58d6f1a8.png";